<template>
  <div class="pa-3">
    <h2 class="title mt-0 mb-3">{{ title }}</h2>
    <v-card>
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/components/document/DocumentDetail.vue